import type { UploadImportPreview } from "../api/imports";

export default function ImportCompletenessNotice({ report, onPage }: {
  report?: UploadImportPreview["document_completeness"];
  onPage?: (page: number) => void;
}) {
  if (!report?.issues.length) return null;
  const missingPositions = report.issues.some(issue => issue.code === "document_positions_missing");
  const visibleIssues = report.issues.filter(issue =>
    (!report.blocking || issue.blocking) && !(missingPositions && issue.code === "document_no_positions"));
  return <section aria-label="Vollständigkeit prüfen" className="space-y-3 border-b border-slate-200 pb-4">
    <h3 className="font-semibold">{report.blocking ? "Beleg noch nicht vollständig eingelesen" : "Belegsumme prüfen"}</h3>
    <ul className="divide-y divide-slate-200 text-sm">
      {visibleIssues.map((issue, index) => <li key={`${issue.code}-${index}`} className="flex items-start justify-between gap-3 py-2">
        <span className="text-slate-700">{issue.message}</span>
        {issue.page_no && onPage && <button type="button" onClick={() => onPage(issue.page_no!)} className="h-9 shrink-0 rounded-md border border-slate-200 bg-white px-3 text-slate-700 hover:bg-slate-50">Seite {issue.page_no}</button>}
      </li>)}
    </ul>
    <p className="text-sm text-slate-600">{report.blocking
      ? "Die Übernahme bleibt gesperrt. Dein Original bleibt gespeichert. Prüfe die Belegart unten. Ist sie richtig, muss die Erkennung für dieses PDF verbessert werden; du kannst die Prüfung offen lassen und später erneut starten."
      : "Vergleiche die Positionsbeträge mit dem Original, bevor du die Übernahme bestätigst."}</p>
  </section>;
}
